import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function useWebsiteReports(agencyId) {
  const staleTime = 600000;
  const queryClient = useQueryClient();

  const { get, post, put, del } = useApiHelper();

  const websiteStats = useQuery(
    ["websiteStats", agencyId],
    () => get(`/Reports/${agencyId}/websitestats`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    websiteStats,
  };
}
